import { IonRouterLink } from '@ionic/react'
import { observer } from 'mobx-react'
import moment from 'moment-timezone'
import React, { useContext, useEffect } from 'react'
import styled from 'styled-components'
import { PagingContent } from '../../../components'
import { DivideLine } from '../../../components/atoms/divide'
import { StoresContext } from '../../../provider/StoreProvider'

export const MainEvent: React.FC = observer(() => {
  const { artfairStore } = useContext(StoresContext)
  const pagingStore = artfairStore.eventPagingStore

  useEffect(() => {
    pagingStore.load(undefined, true)
  }, [])

  return (
    <>
      <PagingContent pagingStore={pagingStore} emptyText={'조회 가능한 이벤트 정보가 없습니다.'}>
        {pagingStore.list.map((d, i) => (
          <IonRouterLink key={i} color={'dark'} routerLink={`/artfair/${d.id}/event`}>
            <EventContainer>
              <img
                src={d.imageUri}
                alt={d.title}
                onError={({ currentTarget }) => {
                  currentTarget.onerror = null
                  currentTarget.src = '/img/thumbnail.svg'
                }}
              />
              <ContentContainer>
                <p className="title">{d.title ?? '-'}</p>
                <p className="content">{d.contents.map((c) => c.type === 'header' && c.content)}</p>
                <p className="date">{moment(new Date(d.createdDate)).format('MM월 DD일')}</p>
              </ContentContainer>
            </EventContainer>
            <DivideLine />
          </IonRouterLink>
        ))}
      </PagingContent>
    </>
  )
})

const EventContainer = styled.div`
  padding: 20px;
  display: grid;
  grid-template-columns: repeat(8, 1fr);
  grid-template-rows: 1fr;
  img {
    object-fit: cover;
    min-width: 60px;
    height: 60px;
    border-radius: 4px;
  }
  :hover {
    background-color: var(--ion-color-gray100);
  }
`

const ContentContainer = styled.div`
  margin-left: 16px;
  grid-area: 1 / 2 / 2 / 9;
  display: flex;
  flex-direction: column;
  p {
    margin: 0;
  }
  .title {
    font-size: 15px;
    font-weight: 700;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .content {
    font-size: 14px;
    font-weight: 400;
    color: var(--ion-color-primary_light);
    margin-bottom: 5px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .date {
    font-size: 12px;
    font-weight: 400;
    color: var(--ion-color-gray400);
  }
`
